import { Component, OnInit } from '@angular/core';
import { AuditService } from 'src/app/core/services/audit.service';
import { UserProfileService } from 'src/app/core/services/user.service';
import * as principale from '../../../../assets/ukey.json';
import { Decrypt } from 'src/app/pages/functions/functions';
import { MailService } from 'src/app/core/services/mail.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationService } from '../../../core/services/authorization.service';
@Component({
  selector: 'app-token-modal',
  templateUrl: './token-modal.component.html',
  styleUrls: ['./token-modal.component.scss']
})
export class TokenModalComponent implements OnInit {
  toketxt:string = '';
  valid_data:any = principale;
  usuarios:any;
  usuario:any;

  constructor( private userService:UserProfileService, private auditService: AuditService
                ,private mailService:MailService, public activeModal:NgbActiveModal,private _authorizationService:AuthorizationService) { }

  ngOnInit(): void {
    this.getUsuarios();
  }
validar(){

    if (this.toketxt === this.valid_data.data) {

      this.auditService.registrar({
    
        roleName:
          Decrypt(this.userService.usuario.profile) || 'User',
    
        responsibleUser:
          Decrypt(this.userService.usuario.name) || 'Unknown',
    
        actionName: 'VALIDACION',
    
        moduleName: 'TOKEN',
    
        movement:
          `Validó correctamente un token local y continuó con el proceso`,
    
        urlEndpoint:
          '/token/validate-local',
    
        previousData: null,
    
        newData: JSON.stringify({
          token: this.toketxt
        }),
    
        statusName: 'CORRECTO',
    
        createdBy:
          Decrypt(this.userService.usuario.name) || 'System'
    
      });

      this.activeModal.close(true);

    } else {
    
      this.mailService.validateToken(this.toketxt).subscribe(
    
        (resp: any) => {
    
          if (resp.ok) {
    
            this.auditService.registrar({
    
              roleName:
                Decrypt(this.userService.usuario.profile) || 'User',
    
              responsibleUser:
                Decrypt(this.userService.usuario.name) || 'Unknown',
    
              actionName: 'VALIDACION',
    
              moduleName: 'TOKEN',
    
              movement:
                `Validó correctamente un token mediante servicio externo`,
    
              urlEndpoint:
                '/token/validate',
    
              previousData: null,
    
              newData: JSON.stringify({
                token: this.toketxt
              }),
    
              statusName: 'CORRECTO',
    
              createdBy:
                Decrypt(this.userService.usuario.name) || 'System'
    
            });
    
           this.activeModal.close(true);
    
          } else {
    
            this.auditService.registrar({
    
              roleName:
                Decrypt(this.userService.usuario.profile) || 'User',
    
              responsibleUser:
                Decrypt(this.userService.usuario.name) || 'Unknown',
    
              actionName: 'VALIDACION',
    
              moduleName: 'TOKEN',
    
              movement:
                `Intentó validar un token inválido`,
    
              urlEndpoint:
                '/token/validate',
    
              previousData: null,
    
              newData: JSON.stringify({
                token: this.toketxt
              }),
    
              statusName: 'ERROR',
    
              createdBy:
                Decrypt(this.userService.usuario.name) || 'System'
    
            });
    
           this.activeModal.close(false);

          }
    
        },
    
        err => {
    
          this.auditService.registrar({
    
            roleName:
              Decrypt(this.userService.usuario.profile) || 'User',
    
            responsibleUser:
              Decrypt(this.userService.usuario.name) || 'Unknown',
    
            actionName: 'VALIDACION',
    
            moduleName: 'TOKEN',
    
            movement:
              `Error al validar token`,
    
            urlEndpoint:
              '/token/validate',
    
            previousData: null,
    
            newData: JSON.stringify({
              token: this.toketxt,
              error: err?.message || err
            }),
    
            statusName: 'ERROR',
    
            createdBy:
              Decrypt(this.userService.usuario.name) || 'System'
    
          });
    
           this.activeModal.close(false);
    
        }
    
      );
    
    }

 
  }

   getUsuarios() {

  this.userService.getUsuarios().subscribe({

    next: (resp: any) => {

      this.usuarios = resp.filter((usuario: any) =>
        usuario.type_id === 28
      );

    },

    error: (err) => {

      console.error(err);

    }

  });

}


solicitarToken(){
    this._authorizationService.requestAuthorization(this.usuario.id,'Necesita autorizacion para realizar tarea').subscribe((resp:any) =>{
     
      console.log(resp);
     
      if(resp.ok){
        // Swal.fire({
        //   title: 'Correto!',
        //   text:  `Email envido`,
        //   icon: 'success',
        //   confirmButtonText: 'aceptar'
        // })
      }else{
        // Swal.fire({
        //   title: 'Error!',
        //   text:  `Error al enviar el email,revice configuración global`,
        //   icon: 'error',
        //   confirmButtonText: 'aceptar'
        // })
      }
      this.usuario = null;
      // this.closeModal();
    })


  }
}
